import type { AxiosInstance } from '@glovo/fetcher'
import type { WhatsUpResponse } from '../entities'
import { WhatsUpSchema } from '../entities'
import { getConfig } from '@/tools/config'
import { safeParse } from '@/tools/schema-validation'

export const whatsUp = async (
  fetcherInstance: AxiosInstance,
  fields: string
): Promise<WhatsUpResponse> => {
  const { apiUrl } = getConfig()
  const response = await fetcherInstance.get(`${apiUrl}/v3/whats_up?fields=${fields}`)
  return safeParse(WhatsUpSchema, response.data)
}
